import { useAuth0 } from '@/utils/auth/auth0'

interface AuthProps {
  children?: React.ReactNode
}

export function Authenticated({ children }: AuthProps) {
  const { isAuthenticated } = useAuth0()
  return isAuthenticated ? <>{children}</> : null
}

export function Unauthenticated({ children }: AuthProps) {
  const { isAuthenticated } = useAuth0()
  return !isAuthenticated ? <>{children}</> : null
}
